import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '#000000',
    pageBackground: '#DDD8FF',
  },
  fonts: {
    body: fontStacks.satoshi.value,
    heading: fontStacks.satoshi.value,
  },
});

export const dusk = createTheme({ ...mergedTokens });
